/* eslint-disable import/prefer-default-export */
// import { normalize } from 'normalizr';
import { DashboardStatResponse } from 'signature-public-api-sdk';
import { AppThunk } from '€slices/types';
import { requestData, receiveDataFailure } from './dashboard-slice';
import { receiveStatsSuccess } from '../stats';
import { loadingDashboardInit, finishedDashboardInit } from '~/src/slices/network/network-slice';
import api from '€api/client';
// import { NormalizedDashboardEntities } from '€slices/entity-types';
import { callApi } from '€slices/network/network-thunks';
import { loadingDashboard } from '€slices/network/network-selectors';

export const initialiseDashboard = (): AppThunk => async (dispatch, getState) => {
    if (loadingDashboard(getState())) {
        return;
    }

    dispatch(requestData());
    dispatch(loadingDashboardInit());

    const [error, data] = await dispatch(
        callApi<DashboardStatResponse>(api.BrokerPortal.Dashboard.init()),
    );

    dispatch(finishedDashboardInit());

    if (data) {
        dispatch(receiveStatsSuccess({ ...data }));
    } else {
        dispatch(receiveDataFailure({ error: String(error.response) }));
    }
};
